import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Async actions for synck
export const updateOrCreateSynck = createAsyncThunk(
  "synck/updateOrCreateSynck",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/update-or-create-synck", info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserSynck = createAsyncThunk(
  "synck/getUserSynck",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/get-user-synck", {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeFromSynck = createAsyncThunk(
  "synck/removeFromSynck",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/remove-from-synck", info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Synck reducer
export const synckReducer = createSlice({
  name: "synck",
  initialState: {
    synckData: [],
    successMessage: "",
    errorMessage: "",
    loader: false,
  },
  reducers: {
    messageClear: (state) => {
      state.successMessage = "";
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOrCreateSynck.pending, (state) => {
        state.loader = true;
      })
      .addCase(updateOrCreateSynck.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.synckData = payload.synck;
      })
      .addCase(updateOrCreateSynck.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      .addCase(getUserSynck.pending, (state) => {
        state.loader = true;
      })
      .addCase(getUserSynck.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.synckData = payload.synck;
      })
      .addCase(getUserSynck.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      .addCase(removeFromSynck.pending, (state) => {
        state.loader = true;
      })
      .addCase(removeFromSynck.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.synckData = payload.synck;
      })
      .addCase(removeFromSynck.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      });
  },
});

export default synckReducer.reducer;

export const { messageClear } = synckReducer.actions;
